import { render, staticRenderFns } from "./usedCar.vue?vue&type=template&id=27f655ca&scoped=true&"
import script from "./usedCar.vue?vue&type=script&lang=js&"
export * from "./usedCar.vue?vue&type=script&lang=js&"
import style0 from "./usedCar.vue?vue&type=style&index=0&id=27f655ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f655ca",
  null
  
)

export default component.exports